import { EventFormData } from '~admin/view/components/details/event-form-data';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import { datetime } from '~common/helper/datetime';

/**
 * Transforms EventDatetimeDetailsFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventDatetimeDetailsRequest = (
  values: EventFormData,
): Pick<
  EventProfileCreateRequest,
  | 'eventDate'
  | 'eventEndDate'
  | 'onlineVisibleDate'
  | 'onlineHideDate'
  | 'doorsOpenDate'
  | 'doorsCloseDate'
> => {
  const {
    eventDateTimeStart,
    eventDateTimeEnd,
    discoverDateStart,
    discoverDateEnd,
    doorsOpenDate,
  } = values;

  return {
    eventDate: datetime.parse(eventDateTimeStart).toISOString(),
    eventEndDate: datetime.parse(eventDateTimeEnd).toISOString(),
    onlineVisibleDate: datetime.parse(discoverDateStart).toISOString(),
    onlineHideDate: datetime.parse(discoverDateEnd).toISOString(),
    doorsOpenDate: datetime.parse(doorsOpenDate).toISOString(),
    doorsCloseDate: datetime.parse(eventDateTimeEnd).toISOString(),
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-datetime-details-request.helper.ts